import { useState } from "react";
import type { Asset } from "@forgepoint/shared";
import { AttachmentPill } from "@/components/AttachmentPill";
import { AssetPreviewDialog } from "@/components/AssetPreviewDialog";
import { useAssetsByIds } from "@/hooks/useAssetsByIds";

/**
 * Displays the assets of an attachments custom field as pills; clicking a pill
 * opens its preview.
 */
export function AttachmentsFieldDisplay({ assetIds }: { assetIds: string[] }) {
  const [previewAsset, setPreviewAsset] = useState<Pick<
    Asset,
    "id" | "fileName"
  > | null>(null);
  const assets = useAssetsByIds(assetIds);

  if (assets.length === 0) {
    return null;
  }
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {assets.map((asset) => (
        <AttachmentPill
          key={asset.id}
          fileName={asset.fileName}
          onClick={() => setPreviewAsset(asset)}
        />
      ))}
      <AssetPreviewDialog
        assetId={previewAsset?.id ?? null}
        fileName={previewAsset?.fileName}
        onClose={() => setPreviewAsset(null)}
      />
    </div>
  );
}
